/**
 * QUIL: is a local store bound to this tab yet (W12 A5)?
 *
 * Before a store is bound `db` has nothing behind it and a read throws `NoStoreError`, so anything
 * that sits above the gates (the App shell's boot effect) waits on this instead of touching the
 * library. True the moment `storeBinding` has bound one, and in the dev bypass once the local store
 * is open.
 */
import { useSyncExternalStore } from 'react'
import { getActiveDb, subscribeActiveDb } from './db'

const snapshot = (): boolean => getActiveDb() !== null

export function useStoreBound(): boolean {
  return useSyncExternalStore(subscribeActiveDb, snapshot, snapshot)
}
